<div class="row mb-3">
  <label class="col-form-label col-xl-2">รอบการแจ้งเตือน</label>
  <label class="col-form-label col-auto">ปีงบประมาณ</label>
  <div class="col-xl-1">
    <select class="form-select" [(ngModel)]="params().budgetYear" id="notif-year" (change)="selectYear()" name="notif-year">
      <option *ngFor="let item of years" [value]="item">{{item + 543}}</option>
    </select>
  </div>
  <label class="col-form-label col-auto">รอบที่ - เดือน</label>
  <div class="col-xl-2">
    <select class="form-select" id="notif-monthly" (change)="selectRound()" [compareWith]="comparator" [(ngModel)]="params()['roundDto']" name="notif-monthly">
      <option [ngValue]="undefined">ทั้งหมด</option>
      <option *ngFor="let item of roundDtos"
              [ngValue]="item">{{item.name}}</option>
    </select>
  </div>
</div>
